export const getCategoryPath = (categorySlug: string) => `/category/${categorySlug}/`;

export const getSubcategoryPath = (categorySlug: string, subcategorySlug: string) =>
  `/category/${categorySlug}/${subcategorySlug}/`;
